export default function cancelablePromise (func, cancelArgs) {
  cancelArgs = cancelArgs || [];
  let cancel = null;

  return function (...args) {
    if (cancel) {
      cancel(cancelArgs);
      cancel = null;
    }
    const cancelpromise = new Promise(_resolve => { cancel = _resolve; }, () => { });

    return Promise.race([func(...args), cancelpromise]);
  };
};
